module.exports = __webpack_public_path__ + "c1d87faeedb9df3349db45d6efb5afb8.png";